import { Button } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { FiFile } from "react-icons/fi"
import { useFileDownloader } from "../../hooks";
import React, { useState } from "react";


const ButtonDownloadTemplate = ({text, apiUrl, ...props}) => {
    const [processing, setProcessing] = useState(false);
    const tmpProps = {
        ...props,
        theme: tenkenTheme.button,
        color: "success",
        className: `rounded-[6px] min-w-[300px] h-[40px] ${props.className} ${processing && 'pointer-events-none'}`,
    };
    const {downloadFileFromPath} = useFileDownloader();
    const handleDownload = () => {
        setProcessing(true);
        downloadFileFromPath(apiUrl).finally(() => setProcessing(false));
    };

    return (
      <Button onClick={() => handleDownload()} isProcessing={processing} {...tmpProps}>
          <FiFile className="mr-[4px]" size={20} />
          {text}
      </Button>
    );
};

export default ButtonDownloadTemplate;